(function () {
  if (window.SenbederProductProcurementReady) return;
  window.SenbederProductProcurementReady = true;

  function number(value) {
    return Math.max(0, Number(value) || 0);
  }

  function quantityFor(button) {
    var root = button.closest('[data-product-procurement-root]') || document;
    var productInfo = button.closest('[id^="ProductInfo-"]') || root;
    var input = productInfo.querySelector('input[name="quantity"]');
    return Math.max(1, Math.floor(number(input && input.value) || 1));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-product-quote-button]');
    if (!button || button.disabled) return;

    var store = window.SenbederQuoteStore;
    if (!store || typeof store.add !== 'function') return;

    store.add({
      id: button.dataset.productId,
      title: button.dataset.productTitle,
      xbd: button.dataset.productXbd,
      desc: button.dataset.productDesc,
      moq: button.dataset.productMoq,
      basePrice: number(button.dataset.productBasePrice),
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      market: 'Product page'
    }, quantityFor(button), 'product-page');

    var label = button.querySelector('span');
    var original = label ? label.textContent : '';
    if (label) label.textContent = 'Added to Procurement List';
    store.open('product-page');
    window.setTimeout(function () {
      if (label) label.textContent = original || 'Add to Procurement List';
    }, 1600);
  });
})();
